export default "__VITE_ASSET__gBQWp4vK__"